import { createAction } from 'typesafe-actions'
import { Signal } from '@bdswiss/mt4-connector'

export const signalsUpdatedAction = createAction('@signals/updated')<string[]>()
export const signalsTickAction = createAction('@signals/tick')<Signal>()
